
export const numberToFixedHalfDown = (num: number, decimals: number = 0) => {
  const factor = Math.pow(10, decimals);
  const n = num * factor;
  const result = (n % 1 > 0.5) ? Math.ceil(n) : Math.floor(n);

  return (result / factor).toFixed(decimals);
};
